import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import { useSelectorToStore } from '@hooks/reduxHooks';
import dateHelper from '@utils/dates';
import { Context as IsMobileContext } from '../../../Context/IsMobileContext';
import { sectionsIds } from '../sections';
import {
  Spacings,
  Fonts,
  mobile,
  TextColors,
  BgColors
} from '../../../../styleConstants';
import SectionContainer from '../SectionContainer';
import Schedule from './Schedule/Schedule';
import ScheduleMobile from './ScheduleMobile/ScheduleMobile';

const DatesHeader = styled.div`
  padding: ${Spacings.SPACING_6B} 0px ${Spacings.SPACING_6B} 144px;
  display: grid;
  grid-template: 1fr / repeat(${({ $cols }) => $cols}, 1fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  position: sticky;
  top: 70px;
  background-color: ${BgColors.BASE};
  z-index: 10;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    grid-column-gap: ${Spacings.SPACING_2B};
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_5B};
    position: static;
  }
`;

const DateItem = styled.span`
  font-weight: normal;
  font-size: 40px;
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  color: ${({ $isSelected }) => ($isSelected ? '#0b1a3e' : '#7b8ab5')};
  text-align: left;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-weight: ${Fonts.SEMIBOLD};
    font-size: ${Fonts.H5};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_4B};
    color: ${({ $isSelected }) => ($isSelected ? TextColors.WHITE : '#7b8ab5')};
    background-color: ${({ $isSelected }) =>
      $isSelected ? '#1f2432' : BgColors.WHITE};
    border-radius: ${Spacings.SPACING_6};
    cursor: pointer;
    text-align: center;
  }
`;

const SummitSchedule = ({ headerRefs }) => {
  const isMobileDevice = useContext(IsMobileContext);
  const schedule = useSelector(({ summit }) => {
    return summit.schedule;
  });
  const staticTexts = useSelector(({ summit }) => summit.staticTexts);
  const dates = schedule.map((daySchedule) => daySchedule.date);
  const [selectedDate, setSelectedDate] = useState(dates[0]);

  useEffect(() => {
    if (window) {
      setSelectedDate(
        dates.find((date) =>
          dateHelper.isSameDay(new Date(date), new Date())
        ) || (isMobileDevice ? dates[0] : null)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDateClick = (date) =>
    isMobileDevice
      ? () => {
          setSelectedDate(date);
        }
      : undefined;
  return (
    <SectionContainer
      title="Schedule"
      color="#10A5D4"
      sectionId={sectionsIds.schedule}
      headerRefs={headerRefs}
      contentMarginTop={isMobileDevice ? Spacings.SPACING_10B : '120px'}
      quote={staticTexts.scheduleHeader || ''}
      description={staticTexts.scheduleDesc || ''}
    >
      <DatesHeader $cols={dates.length}>
        {dates.map((date) => (
          <DateItem
            key={date}
            $isSelected={date === selectedDate || selectedDate === null}
            onClick={onDateClick(date)}
          >
            {dateHelper.getDateShort(date, false)}
          </DateItem>
        ))}
      </DatesHeader>
      {!isMobileDevice && <Schedule schedule={schedule} dates={dates} />}
      {isMobileDevice && (
        <ScheduleMobile schedule={schedule} selectedDate={selectedDate} />
      )}
    </SectionContainer>
  );
};

SummitSchedule.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default SummitSchedule;
